// extracted by mini-css-extract-plugin
module.exports = {"container":"smoothResizer_container_2yvTq","content":"smoothResizer_content__E_Te"};